import React from 'react'
import '../styles/article.css'

const EchoesCH5 = () => {
    return (
        <div className='echoes-chapter'>
            <h1 className='ec-h1'>Chapter 5: A Star in the Making</h1>

            <p>When I walked back into the theater, Barbara was seated next to a woman I didn’t
                recognize, her laughter filling the space like music that lingered in the rafters. As I
                approached, Barbara waved me over, her face flushed, eyes glistening with tears of
                mirth.</p>
            <p>“Ellen, meet Cora from Iowa,” Barbara said between breaths, her voice warm with
                the kind of camaraderie that comes from shared humor. “She’s here to see her son
                perform in the competition.”</p>
            <p>Cora turned to me, her handshake firm but kind, her smile radiating a natural
                warmth. “Thank you so much for this seat—it’s perfect! I feel like I won the lottery
                just being here. Stoney’s Iowa group isn’t up yet, but I didn’t want to miss a second of
                the show.”</p>

            <p>“It’s lovely to meet you,” I replied, settling into the chair beside her. “But I have to
                know—what’s got you two in stitches?”</p>
            <p>Cora grinned, her eyes crinkling with a hint of mischief. “I was telling Miss Barbara
                here about life on our dairy farm and, well... let’s just say she’s never heard
                deworming described quite so vividly.”</p>
            <p>Barbara, still catching her breath, added, “Let’s just say I’ll be seeing buttered corn
                on the cob differently from now on.”</p>

            <p>I chuckled, deciding that some details are better left unexplored. There was a certain
                charm to Cora—her unpolished honesty, her deep connection to a life so different
                from our own—and I found myself instantly drawn to her authenticity.</p>
            <p>As the performances began, Cora’s enthusiasm grew with every choir that took the
                stage. Her whispers—“Can you believe these are high school students?” or “Is this
                the kind of dancing they do on Broadway?”—brought a smile to my face every time.
                Watching her wonder reminded me of why I fell in love with show choir in the first
                place: it wasn’t just the talent; it was the way it could make the ordinary feel
                extraordinary.</p>
            <p>When Stoney’s choir stepped onto the stage, Cora’s excitement was palpable. They
                wore costumes straight out of a country dream—cowboy boots, plaid shirts, and a
                barn backdrop painted with the words “See Rock City.” But it wasn’t just the
                costumes or the choreography that captivated the audience. It was Stoney.</p>

            <p>He stepped forward, adjusting the mic stand with the easy confidence of someone
                born to command attention. As his fingers brushed the strings of his mandolin, the
                first chords of “I Was Country When Country Wasn’t Cool” rippled through the
                theater. His voice was rich and raw, carrying the weight of his years on the farm and
                the dreams that stretched far beyond it. In that moment, the world seemed to tilt,
                all eyes locked on this boy who had transformed into something extraordinary.</p>
            <p>By the time the results were announced, Cora’s hands were red from clapping, her
                eyes glistening with unshed tears. Stoney’s choir had won their division, and he had
                been named Outstanding Soloist—a title he carried with the same effortless grace
                he brought to the stage.</p>
            <p>Barbara leaned in. “So, what’s next for Stoney?”</p>

            <p>Cora hesitated, then smiled. “In August, he’s moving to Nashville to attend Belmont
                University. We visited last fall, and he fell in love with the campus—and with
                Nashville itself. And they’ve produced some incredible country artists, like Brad
                Paisley, Trisha Yearwood, and Josh Turner.”</p>
            <p>Barbara’s eyes lit up. “Belmont? That’s fantastic! Did you know Levi Kreis, the
                Tony-winning Broadway star from Million Dollar Quartet, went there?”</p>
            <p>Cora continued as if she hadn’t heard Barbara’s Broadway comment. “And Pam Tillis,
                Lee Ann Womack, and Florida Georgia Line.”</p>

            <p>At the mention of Lee Ann Womack, I couldn’t help but jump in. “She’s one of my
                favorites! I was listening to her CD on the drive here.”</p>
            <p>Cora laughed. “Well, maybe one day Stoney will be on that list.”</p>
            <p>As we left the theater, Cora’s pride shone brighter than the midday sun. “He may not
                be a farmer like his daddy wanted,” she said, her voice trembling slightly. “But after
                today, I know he’s exactly where he’s supposed to be.”</p>

            <p>Barbara and I exchanged a glance, the unspoken truth between us clear: sometimes,
                the biggest dreams take the longest roads to find.</p>

        </div>
    )
}

export default EchoesCH5